import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from '../../network/APIEndpoints'
import { sitConfigQrAgentPortal } from '../../network/config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const logoutRequest = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigQrAgentPortal(tokens),
    apiPath: APIEndPoints.Logout,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { logoutRequest }
